import axios, { AxiosRequestConfig } from "axios";
import { createUrl } from "../audio/audioUtil";

const getAxiosConfig = (jwtToken: string): AxiosRequestConfig => {
  return {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
};

/**
 * Check whether an audio file exists in storage without downloading it. The
 * storage proxy answers 404 for missing (or empty) files, and Spring serves
 * HEAD for GET mappings with the status preserved and the body suppressed.
 */
export const checkAudioExists = (
  jwtToken: string,
  objectPath: string,
  callback: (exists: boolean) => void
) => {
  axios
    .head(createUrl(objectPath, "triangula-scout-audio"), getAxiosConfig(jwtToken))
    .then((response) => {
      callback(response.status === 200);
    })
    .catch(() => {
      callback(false);
    });
};

/**
 * Ask the incident's device to upload a slice of its stored audio around the
 * incident. A 200 only means the request was accepted; the outcome arrives as a
 * document in commander/organisations/{orgId}/uploadedIncidents/{incidentId}
 * (see listenForUploadedIncident).
 */
export const requestIncidentAudio = (
  jwtToken: string,
  incidentId: string,
  callback: () => void,
  onError?: (errorMsg: string) => void
) => {
  axios
    .put(
      `https://api.triangula.com/backoffice/incident/${incidentId}/requestAudio`,
      "",
      getAxiosConfig(jwtToken)
    )
    .then((response) => {
      if (response.status === 200) {
        callback();
      } else {
        if (onError) {
          onError("Failed to request audio");
        }
      }
    })
    .catch(() => {
      if (onError) {
        onError("Failed to request audio");
      }
    });
};
